import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=5469264f"
import script from "./ProposalsList.vue?vue&type=script&lang=js"
export * from "./ProposalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports